import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import informationalModuleImageDesktopWebp from './images/clients-shaking-hands-desktop.webp';
import informationalModuleImageMobileWebp from './images/clients-shaking-hands-mobile.webp';
// styles
import { BulletedListStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='whole-life-insurance-financial-planning'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent={false}
      themeType='lightTheme'
      // content
      subHeadingText={<>How much will your whole life <WidowBlock>insurance cost&#63;</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            Many factors can affect the cost of your policy. That&#39;s why your advisor will work with you directly. They&#39;ll ask deeper questions and listen closely to fully understand you and your situation. What you pay monthly (or yearly) will depend on things like:
          </Typography>
          <BulletedListStyled
            disableTopPadding
            bulletType='filledCircle'
            bulletedListData={[
              { bulletText: 'Your goals and needs' },
              { bulletText: 'Your coverage amount' },
              { bulletText: 'Your age and health' },
              { bulletText: 'Added riders' },
            ]}
          />
          <Link
            id='whole-life-insurance-financial-planning-fafa-cta'
            variant='buttonLinkPrimary'
            linkUrl= '/find-a-financial-advisor/'>
            Connect with an advisor
          </Link>
        </>
      )}
      // image props
      imageAltText='A happy couple shaking hands with a financial advisor.'
      imageSrcDefault={informationalModuleImageDesktopWebp.toString()}
      imageSrcMobile={informationalModuleImageMobileWebp.toString()}
    />
  );
};
